export default {
  STATIC_BLOCK_START_TIME: "2022-01-01T12:00:00Z",
};
